import { Component } from '@angular/core';
import { animate, state, style, transition, trigger, AnimationEvent } from '@angular/animations';

/**
 * Navigation component used to display nav bar with menu options
 */
@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  animations: [
    trigger('navigationCollapse',
      [
        state('collapsed', style({ width: '80px' })),
        state('expanded', style({ width: '*' })),
        transition('expanded <=> collapsed', animate('50ms linear'))
      ]),
    trigger('displayChange',
      [
        state('collapsed', style({ display: 'none' })),
        state('expanded', style({ display: '*' }))
      ]),
    trigger('imageRotate',
      [
        state('collapsed', style({ transform: 'rotate(180deg)' })),
        state('expanded', style({ transform: '*' }))
      ])
  ]
})
export class NavigationComponent {
  // props
  collapsed = true;
  hideMenuText = false;

  // methods
  collapse() {
    this.collapsed = !this.collapsed;
  }

  /**
  * Event - setting up menu text hidden/visible on animation starts/ends
  * @param event 
  */
  onNavAnimationEvent(event: AnimationEvent) {
    if (event.toState === 'collapsed' && event.phaseName === 'start') {
      this.hideMenuText = true;
    }
    if (event.toState === 'expanded' && event.phaseName === 'done') {
      this.hideMenuText = false;
    }
  }
}
